export const projects = [
  // {
  //     title: 'React Portfolio',
  //     images: [
  //         'https://i.ibb.co/df557nk/Screenshot-5.png',
  //         'https://i.ibb.co/M5kSTNB/Screenshot-6.png',
  //     ],
  //     sourceCodeLink: 'https://github.com/TheCoderDream/react-portfolio',
  //     demoLink: 'https://emrebaskan.netlify.app/',
  //     type: 'react'
  // },
  {
    title: "React Services App With Redux",

    images: [
      "https://drive.google.com/file/d/12uYF0rMMrOvs97Crl1xip0_WxY32Y-Xd/view",
      "https://drive.google.com/file/d/1BV1gdyOfGhXBB4aP8gn04SX18ka6y9fO/view",
      "https://drive.google.com/file/d/1ZgAWWuLji5MVIBB_1LKM3zQn6XLe1dke/view",
      //   "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm1-1.png",
      //   "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm2-2.png",
      //   "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm4.png",
    ],
    // sourceCodeLink:
    //   "https://github.com/TheCoderDream/React-Ecommerce-App-with-Redux",
    demoLink: "http://13.126.8.176/",
    type: "react",
  },
  {
    title: "Vue Ecommerce App With Vuex",
    images: [
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm1-1.png",
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm2-2.png",
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm4.png",
    ],
    // sourceCodeLink:
    //   "https://github.com/TheCoderDream/Vue-Ecommerce-App-with-Vuex",
    demoLink: "http://sincere-wind.surge.sh/",
    type: "vue",
  },
  {
    title: "Angular Ecommerce App With Ngrx",
    images: [
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm1-1.png",
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm2-2.png",
      // "https://github.com/TheCodersDream/React-Ecommerce-App-with-Redux/raw/master/ecm4.png",
    ],
    // sourceCodeLink:
    //   "https://github.com/TheCoderDream/Angular-Ecommerce-App-with-NGRX",
    demoLink: "http://delirious-coast.surge.sh/",
    type: "angular",
  },
  {
    title: "React Chat App With Redux And Firebase",
    images: [
      // "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_31.png",
      // "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_27.png",
      // "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_28.png",
      // "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_24.png",
      // "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_25.png",
    ],
    // sourceCodeLink:
    //   "https://github.com/TheCoderDream/React-Chat-App-With-Redux-And-Firebase",
    demoLink: "https://react-chat-appp.netlify.app/",
    type: "react",
  },
  {
    title: "Angular Chat app",
    images: [
      "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_31.png",
      "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_27.png",
      "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_28.png",
      "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_24.png",
      "https://github.com/TheCodersDream/Angular-Chat-App/raw/master/Screenshot_25.png",
    ],
    // sourceCodeLink:
    //   "https://github.com/TheCoderDream/React-Chat-App-With-Redux-And-Firebase",
    demoLink: "https://react-chat-appp.netlify.app/",
    type: "angular",
  },
  {
    title: "RxJS Clone",
    images: ["https://i.ibb.co/KGsh7kM/Screenshot-7.png"],
    // sourceCodeLink: "https://github.com/TheCoderDream/rxjs-clone",
    demoLink: "https://stackblitz.com/edit/rxjs-clone?file=index.ts",
    type: "js",
  },
  {
    title: "Lodash Clone",
    images: [
      "https://www.agiliacenter.com/wp-content/uploads/2018/04/Lodash.png",
    ],
    // sourceCodeLink: "https://github.com/TheCoderDream/Lodash-Clone",
    demoLink: "#",
    type: "js",
  },
];
